export class AppConstants {
  public static COMPANY_NAME = 'Soluciones Proapps, SAPI de CV';
  public static COMPANY_COMMERCIAL_NAME = 'PROAPPS';
  public static COMPANY_TAX_ID = 'SPR111004NDA';
  public static SOFTWARE_NAME = 'BASE';
  public static SOFTWARE_VERSION = '1.0';
  public static SOFTWARE_COPYRIGHT = '© 2020';
  public static SUPPORT_WEBPAGE = '';
  public static SUPPORT_EMAIL = 'tonideveloper@gmail.com';
  public static SUPPORT_PHONE = '';
  public static SUPPORT_WHATSAPP = '';
  public static EDUCATION_WEBPAGE = '';
  public static FACEBOOK_WEBPAGE = '';
  public static LINKEDIN_WEBPAGE = '';
  public static OPENPAY_PUBLIC_KEY = 'pk_aaaaaa';
  public static OPENPAY_MERCHANT_ID = 'mals';
  public static IMAGE_AVATAR_DEFAULT = 'assets/images/avatar.png'
}
